import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { customerActions } from '../../modules/Actions';
import { CommonResult } from '@common/external/Common';

const initialState: CommonResult = { jobDateTime: '', resultCd: '0000' };

export const ErrorReducer = reducerWithInitialState(initialState)
  .case(customerActions.fetchMailUnsubscribe.failed, (state: CommonResult, payload) => {
    return payload.error;
  })
  .case(customerActions.resetError, (state: CommonResult, payload) => {
    return initialState;
  });
